import { XMLParser } from 'fast-xml-parser';

import { GenericHttpError } from '@iconik-io/core/src/http/generic_http_transport';
import { isString } from '@iconik-io/core/src/is_string';

import { UploadError } from '../../errors';

export class GcsInvalidComposeResponseError extends UploadError {
  constructor(message?: string) {
    super(message ?? 'Invalid compose response');
  }
}

export class GcsComposeUnsupportedError extends UploadError {
  constructor() {
    super('Composing multipart uploads is not supported for this upload kind');
  }
}

export type GcsErrorInfo = { code: string; message: string };

export class GcsApiError extends UploadError {
  constructor(
    public errorInfo: GcsErrorInfo,
    public cause: GenericHttpError,
  ) {
    super(`${errorInfo.message} (${errorInfo.code})`);
  }
}

const parseGcsError = (body: string): GcsErrorInfo | undefined => {
  const parser = new XMLParser({ ignoreAttributes: true });
  const parsed = parser.parse(body);
  const code = parsed.Error?.Code;
  const message = parsed.Error?.Message;

  if (!code || !message) {
    return undefined;
  }
  return { code, message };
};

/**
 * Rethrows an error that originated from the GCS XML API carrying its error
 * info, and anything else untouched.
 */
export const handleGcsApiError = (reason: unknown): never => {
  if (reason instanceof GenericHttpError && isString(reason.response.body)) {
    const errorData = parseGcsError(reason.response.body);
    if (errorData) {
      throw new GcsApiError(errorData, reason);
    }
  }
  throw reason;
};
